module.exports = __webpack_public_path__ + "static/media/70.0c9c005f.png";